import React, { Component } from 'react';
import NavLink from '../Navigation/NavLink';
import OtherSideComponents from '../Navigation/OtherSideComponents';

class SideBar extends Component {
    render() {
        return (
            <ul id="navigation">
                <NavLink />
                <OtherSideComponents />
            </ul>
        )
    }
}
export default SideBar;


// WEBPACK FOOTER //
// ./src/Components/Menu/SideBar.js